export const FILTER_TRANSACTIONS_STARTED = "FILTER_TRANSACTIONS_STARTED";
export const FILTER_TRANSACTIONS_SUCCEEDED = "FILTER_TRANSACTIONS_SUCCEEDED";
export const FILTER_TRANSACTIONS_FAILED = "FILTER_TRANSACTIONS_FAILED";
export const SET_TRANSACTION_LIST = "SET_TRANSACTION_LIST";